// extracted by mini-css-extract-plugin
export default {"toggleAllSelectionsHeader":"toggleAllSelectionsHeaderComponent_toggleAllSelectionsHeader__gahVj","checkbox":"toggleAllSelectionsHeaderComponent_checkbox__xp+Tm"};